import AiTopNav from './index.v0.4.1.js'
const aitopnav = {
  AiTopNav
}
export default aitopnav



// WEBPACK FOOTER //
// ./src/components/AiTopNav/index.js